import FormAmount from './Form.Amount';
import FormDestination from './Form.Destination';

export const Form = () => (
	<form className='payment-request-form'>
		<FormAmount />
		<FormDestination />
	</form>
);
